import React from "react";
import StaticContentPage from "./StaticContentPage";
import { faqsText } from "../data/staticPagesContent";

const FAQs = () => {
  return (
    <StaticContentPage
      title="Frequently Asked Questions"
      seoTitle="FAQs | Eveness Help & Shopping Questions"
      seoDescription="Find answers to common questions about Eveness, shopping, orders, returns, payments, account support, and product guidance."
      canonicalPath="/faqs"
    >
      {faqsText}
    </StaticContentPage>
  );
};

export default FAQs;